module.exports = __webpack_public_path__ + "img/logo.e2f75a69.svg";